<template>
    <div class="apprentice-simple-card">
        <p>
            {{ $t('group.you_can_approve_all_magazines_in_the_current_group_and_all_subgroups_at_once_here') }}
        </p>
        <p>
            {{
                $t(
                    'group.when_you_use_the_option_below_everything_is_automatically_approved_and_the_pdf_files_are_created',
                )
            }}
        </p>
        <p>
            {{
                $t(
                    'group.depending_on_the_number_of_magazines_and_the_number_of_pages_per_magazine_this_may_take_a_moment',
                )
            }}
        </p>

        <b-button
            variant="primary"
            @click="approveAll"
            >{{ $t('group.approve_everything') }}</b-button
        >
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-magazine-admin-component',
    props: ['groupIn'],
    methods: {
        approveAll() {
            this.alert
                .confirm(
                    this.$t('group.approve_everything'),
                    this.$t('group.are_you_sure_you_want_to_approve_everything'),
                    this.$t('group.yes_approve'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        const data = {
                            group_id: this.groupIn.id,
                        };

                        this.axios.post(this.routes.groupApproveAll(this.groupIn.id), data).then(
                            (response) => {
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss"></style>
